import * as types from './actionTypes';
import {FUNDING_APP_BASE_URL} from '../constants/global';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function merchantDataURL(){
  const url = `${FUNDING_APP_BASE_URL()}merchants`;
  return url;
}

export function fetchMerchantData() {
  return dispatch => {
    return authenticatedFetch(merchantDataURL(), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(receiveMerchantData(json));
    });
  };
}

export function receiveMerchantData(json) {
  return {type: types.RECEIVE_MERCHANT_DATA, merchantData: json };
}
